// extracted by mini-css-extract-plugin
export default {"wrapper":"HistoryViewer_wrapper__DSQmh","title":"HistoryViewer_title__k2YRK","toolbar":"HistoryViewer_toolbar__0R6aB","spinner_box":"HistoryViewer_spinner_box__1Qhwo"};